import { connect } from 'react-redux';
import {
  updateDeal,
} from '../../../redux/actions/deal-actions';
import {
  fetchCommercialProperty,
  updateVoucher,
} from '../../../redux/actions/voucher/voucher-actions';
import { fetchFiles, uploadFile } from '../../../redux/actions/deal-files-actions';
import { fetchFinancials } from '../../../redux/actions/financial-actions';
import LeaseInformation from './LeaseInformationTab';


const mapStateToProps = state => ({
  deal: state.deal.deal,
  voucher: state.voucher.voucher,
  commercialProperties: state.voucher.commercialProperties,
  abstractionLeaseFile: state.dealFiles.abstractionLeaseFile,
  dealFiles: state.dealFiles.files,
});

const mapDispatchToProps = {
  updateDeal,
  updateVoucher,
  fetchCommercialProperty,
  fetchFinancials,
  fetchFiles,
  uploadFile,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeaseInformation);
